import '../css/style.css';
import Map from 'ol/Map';
import View from 'ol/View';
import ScaleLine from 'ol/control/ScaleLine';
import { layers, source, index } from './source.js';
import { select, searchNominatim } from './search.js';
import { lswitcher } from './layerSwitcher.js'
import Draw from 'ol/interaction/Draw.js';
import Overlay from 'ol/Overlay.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { getLength } from 'ol/sphere.js';
import { unByKey } from 'ol/Observable.js';
import Permalink from 'ol-ext/control/Permalink'
import { transform } from 'ol/proj';
import ContextMenu from 'ol-contextmenu';
import Notification from 'ol-ext/control/Notification'
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { mapsCollection } from './indexPermalinks.js'
import { magnifiedMaps, mapsToMagnify } from './magnifyingGlass.js';
import Geolocation from 'ol/Geolocation.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Select from 'ol/interaction/Select.js';
import Bar from 'ol-ext/control/Bar';
import Rotate from 'ol/control/Rotate'
import Toggle from 'ol-ext/control/Toggle';


// ----------------------------------------default zoom, center and rotation, map ------------------------------------------------------------------------------
let zoom = 7;
let center = [2075987, 6892066];
let rotation = 0;


//------------measure---------
let sketch;
let helpTooltipElement;
let helpTooltip;
let measureTooltipElement;
let measureTooltip;
const continueLineMsg = 'Kliknij by kontynuować mierzenie, kliknij dwukrotnie by zakończyć';

const pointerMoveHandler = function (evt) {
  if (evt.dragging) {
    return;
  }

  let helpMsg = 'Kliknij by rozpocząć mierzenie';

  if (sketch) {
    helpMsg = continueLineMsg;
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltip.setPosition(evt.coordinate);

  helpTooltipElement.classList.remove('hidden');
};

//-----------index popup-------------
const containerPopup = document.getElementById('popup');
const contentPopup = document.getElementById('popup-content');
const closerPopup = document.getElementById('popup-closer');
const Popup = new Overlay({
  element: containerPopup,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

const view = new View({
  center: center,
  zoom: zoom,
  rotation: rotation,
})

const map = new Map({
  target: 'map',
  layers: layers,
  overlays: [Popup],
  view: view,
});

map.addLayer(index);
//Permalink

// Control
var ctrl = new Permalink({

});
map.addControl(ctrl);



/////////--------------------------------------------Toolbox bar----------------------------------------------------------

// Main control bar
var mainbar = new Bar();
map.addControl(mainbar);
mainbar.setPosition('right');

mainbar.addControl(new Rotate());



// ----------------------------------------------------------Search Photon--------------------------------------------------------------------------------

map.addInteraction(select);

//Search Nominatim

map.addControl(searchNominatim);

// Select feature when click on the reference index
searchNominatim.on('select', function (e) {
  map.getView().animate({
    center: e.coordinate,
    zoom: Math.max(map.getView().getZoom(), 14)
  });
  searchNominatim.clearHistory();
});

// Layer switcher
map.addControl(lswitcher);

// Scale control
map.addControl(new ScaleLine());


///------------------------------------------------------Geolocation/Tracking--------------------------------------------------------

const geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: view.getProjection(),
});

// handle geolocation error.
geolocation.on('error', function (error) {
  const info = document.getElementById('info');
  info.innerHTML = error.message;
  info.style.display = '';
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  }),
);

geolocation.on('change:position', function () {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
});

const trackerLayer = new VectorLayer({
  source: new VectorSource({
    features: [accuracyFeature, positionFeature],
  }),
  displayInLayerSwitcher: false,
});


// Add selection tool (a toggle control with a select interaction)
var geolocTracker = new Toggle({
  html: '<i class="fa-solid fa-location-crosshairs"></i>',
  className: "geolocTracker",
  title: "Geolocation tracker",
  interaction: new Select(),
  active: false,
  onToggle: function (active) {
    if (!active) {
      geolocation.setTracking(false);
      map.removeLayer(trackerLayer);
    } else {
      geolocation.setTracking(true);
      map.addLayer(trackerLayer);

      const onPosition = function () {
        const coordinates = geolocation.getPosition();
        if (coordinates) {
          map.getView().setCenter(coordinates);
          map.getView().setZoom(18);
        }
        geolocation.un('change:position', onPosition); // wyczyść listener po 1 użyciu
      };
      geolocation.on('change:position', onPosition);
    }
  }
});
mainbar.addControl(geolocTracker);


//-------------------------------------------parent-child layer switcher----------

function listenVisible(layer, group) {
  layer.on('change:visible', function (e) {
    if (layer.getLayers) {
      var vis = layer.getVisible();
      var index = 0;

      layer.getLayers().forEach(function (l) {
        if (l.getVisible() == true) {
          index = index + 1;
        }

      });
      if (index == 0 | vis == false) {
        layer.getLayers().forEach(function (l) {
          if (l.getVisible() !== vis) {
            // Prevent infinite loop
            l.setVisible(vis);
          }
        });
      }
    }
    // if inside a group, check visibility of layers in it
    if (group) {
      var vis = false;
      group.getLayers().forEach(function (l) {
        if (l.getVisible()) vis = true;
      });
      if (group.getVisible() !== vis) group.setVisible(vis);

    }
  });

  // Listen to layers in it
  if (layer.getLayers) {
    layer.getLayers().forEach(function (l) {
      listenVisible(l, layer);
    });
  }
}

map.getLayers().getArray().forEach(function (l) {
  listenVisible(l);
});

///-------------measure-----------------------------------

let draw; // global so we can remove it later

const formatLength = function (line) {
  const length = getLength(line);
  let output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

function addInteraction() {
  draw = new Draw({
    source: source,
    type: 'LineString',
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  map.addInteraction(draw);

  createMeasureTooltip();
  createHelpTooltip();

  let listener;
  draw.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    let tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      const geom = evt.target;
      let output;
      output = formatLength(geom);
      tooltipCoord = geom.getLastCoordinate();
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  draw.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip();
    unByKey(listener);
  });
}

/**
 * Creates a new help tooltip
 */
function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  map.addOverlay(helpTooltip);
}

/**
 * Creates a new measure tooltip
 */
function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
    stopEvent: false,
    insertFirst: false,
  });
  map.addOverlay(measureTooltip);
}

function removeElementsByClass(className) {
  const elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}

/**
 * Start measure on click
 */
var measureBtn = new Toggle({
  html: '<i class="fa-solid fa-ruler fa-x1"></i>',
  className: "measureBtn",
  title: "Measure",
  interaction: new Select({ layers: function (layer) { return false; }, }),
  active: false,
  onToggle: function (active) {
    if (!active) {
      map.removeOverlay(measureTooltip);
      map.removeOverlay(helpTooltip);
      map.removeInteraction(draw);
      source.clear();
      removeElementsByClass('ol-tooltip ol-tooltip-static');
    } else {
      map.on('pointermove', pointerMoveHandler);

      map.getViewport().addEventListener('mouseout', function () {
        helpTooltipElement.classList.add('hidden');
      });
      addInteraction();
    }
  }
});
mainbar.addControl(measureBtn);


//--------------------------------------------------------------INDEX----------------------------------------------------------------
let info = null; // Tooltip element
let highlightedFeatures = []; // List of highlighted features
let previousNazwa = ''; // Track the previous tooltip content to avoid duplication
let popupActive = false; // Flag to disable tooltip when popup is active

//Overlay to highlight maps in index
const indexOverlay = new VectorLayer({
  source: new VectorSource(),
  displayInLayerSwitcher: false,
  style: {
    'fill-color': 'rgba(15, 97, 164, 0.0)',
    'stroke-color': 'rgb(255, 204, 51)',
    'stroke-width': 1.8,
  },
});

// Overlay to highlight maps in popup (linkOverlay)
const linkOverlay = new VectorLayer({
  source: new VectorSource(),
  displayInLayerSwitcher: false,
  style: {
    'fill-color': 'rgba(255, 204, 51, 0.55)',
    'stroke-color': 'rgba(255, 255, 255, 0.9)',
    'stroke-width': 2,
  },
});


//----------index tooltip--------//

//feature highlighting and tooltip display on pointer move
map.on('pointermove', function (evt) {
  const pixel = map.getEventPixel(evt.originalEvent);

  //if condition is true hide tooltip, remove highlighted features, reset highlighting variables, reset cursor style
  if (popupActive || evt.dragging || !info || $('.btn-ruler').hasClass('active') || $(".ol-magnify").hasClass('active')) {
    if (info) info.style.visibility = 'hidden';
    highlightedFeatures.forEach(feature => {
      indexOverlay.getSource().removeFeature(feature);
    });
    highlightedFeatures = [];
    previousNazwa = '';
    map.getTargetElement().style.cursor = '';
    return;
  }

  //'features' is a list of maps. Every map is a feature
  const features = [];
  map.forEachFeatureAtPixel(pixel, function (feature) {
    features.push(feature);
  });

  //overlaySource stores highlighted features
  const overlaySource = indexOverlay.getSource();

  //if any feature in list–set cursor style to 'pointer', highlight hovered feature
  if (features.length) {
    map.getTargetElement().style.cursor = 'pointer';

    //firstly remove any previous highlighted feature
    highlightedFeatures.forEach(feature => {
      if (!features.includes(feature)) {
        overlaySource.removeFeature(feature);
      }
    });

    //refresh highlighted features list
    highlightedFeatures = features;

    //add feature to highlight in index overlay
    features.forEach(feature => {
      if (!overlaySource.hasFeature(feature)) {
        overlaySource.addFeature(feature);
      }
    });

    displayFeatureInfo(pixel);
  }

  //if no feature exists
  else {
    map.getTargetElement().style.cursor = ''; //reset cursor style
    info.style.visibility = 'hidden'; //hide tooltip
    overlaySource.clear(); //clear overlaySource
    highlightedFeatures = []; //reset highlightedFeatures
    previousNazwa = ''; //reset previousNazwa
  }
});

//display feature nazwa in tooltip
const displayFeatureInfo = function (pixel) {

  //don't display empty tooltip
  if (!info) return;

  //'features' is a list of maps. Every map is a feature
  const features = [];
  map.forEachFeatureAtPixel(pixel, function (feature) {
    features.push(feature);
  });


  if (features.length) {
    info.style.visibility = 'visible';
    info.style.left = pixel[0] + 'px';
    info.style.top = pixel[1] + 'px';

    const nazwaSet = new Set(features.map(feature => feature.get('nazwa')));
    const nazwaSorted = Array.from(nazwaSet).sort();
    const nazwaText = nazwaSorted.join('<br>');

    if (nazwaText !== previousNazwa) {
      info.innerHTML = nazwaText;
      previousNazwa = nazwaText; // Store the new tooltip content to track changes
    }
  } else {
    info.style.visibility = 'hidden';
    previousNazwa = ''; // Clear the stored tooltip content
  }
};

//Toggle button
$('#mapIndex').change(function () {
  if ($(this).prop('checked')) {
    index.setVisible(true);

    // Add the info element if it doesn't exist
    if (!$('#info').length) {
      $('body').append('<div id="info" style="visibility: hidden; position: absolute; z-index: 1000;"></div>');
      info = document.getElementById('info');
    }
  } else {
    index.setVisible(false);
    $('#info').remove();
    info = null;
    previousNazwa = '';
  }
});

map.addLayer(indexOverlay);
map.addLayer(linkOverlay);

//-------------------------index popup----------------------------//
//close popup
closerPopup.onclick = function () {
  Popup.setPosition(undefined);
  closerPopup.blur();
  popupActive = false;
  return false;
};

//popup with permalinks
map.on('singleclick', function (evt) {

  //if ruler is active do not display popup
  if ($('.measureBtn').hasClass('ol-active')) {
    return;
  }

  //when click on geolocation features do not display popup
  const geolocationFeature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  });
  if (geolocationFeature === accuracyFeature || geolocationFeature === positionFeature) {
    return;
  }


  const coordinate = evt.coordinate;

  const features = [];
  map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    features.push(feature);
  });

  // if any features in list
  if (features.length) {

    //create new set
    const linksSet = new Set();

    //sort features depending on 'nazwa' attribute
    const sortedFeatures = features.sort((a, b) => {
      const nameA = a.get('nazwa') || '';
      const nameB = b.get('nazwa') || '';
      return nameA.localeCompare(nameB);
    });

    //create array of sortedFeatures
    const links = sortedFeatures.map(feature => {
      const nazwa = feature.get('nazwa'); //get features 'nazwa'
      const mapData = mapsCollection.find(map => map.name === nazwa); // and find in mapsCollection accurate link for that feature 
      if (!mapData || linksSet.has(nazwa)) return null; //if no link found or feature has no 'nazwa'–return null
      linksSet.add(nazwa);

      //create permalink for feature
      return `<a class="permalink" href="${mapData.permalink}" target="_blank" data-nazwa='${nazwa}'>${nazwa}</a>`;
    }).filter(link => link !== null); //if any null values filter it out


    //put permalinks in popup 
    contentPopup.innerHTML = `
      ${links.join('<br>')}<hr>
      <a id="copy-button" href="#" class="my-tool-tip" data-toggle="tooltip" data-placement="right" 
         aria-label="Skopiuj do schowka" data-bs-original-title="Skopiuj do schowka">
         <i class="bi bi-box-arrow-up-right"></i>
      </a>
      Kopiuj link do usługi WMS:<br>
      <a href="https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/" data-fr-linked="true">
        https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/
      </a>
    `;

    //popup footer
    $('a.my-tool-tip').tooltip();
    var handleCopyClick = document.querySelector('#copy-button');
    handleCopyClick.addEventListener('click', () => {
      navigator.clipboard.writeText(`https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/`);
      $('a.my-tool-tip').attr('data-original-title', 'WMS skopiowany!');
      $('a.my-tool-tip').tooltip('show');
    });

    //Add hover for links
    document.querySelectorAll('.permalink').forEach(link => {
      link.addEventListener('mouseover', highlightFeature);
      link.addEventListener('mouseout', unhighlightFeature);
    });

    Popup.setPosition(coordinate); //show popup in 'click place'
    info.style.visibility = 'hidden'; //hide tooltip
    popupActive = true; //signalize active popup
  } else {
    Popup.setPosition(undefined);
    popupActive = false;
  }
});



//highlight feature when hover over link
function highlightFeature(evt) {
  const nazwa = evt.target.getAttribute('data-nazwa');

  const featuresToHighlight = [];
  map.getLayers().forEach(layer => {
    if (layer instanceof VectorLayer) {
      layer.getSource().forEachFeature(feature => {
        if (feature.get('nazwa') === nazwa) {
          featuresToHighlight.push(feature);
        }
      });
    }
  });

  featuresToHighlight.forEach(feature => {
    if (!linkOverlay.getSource().hasFeature(feature)) {
      linkOverlay.getSource().addFeature(feature);
    }
  });
}
//unhighlight feature 
function unhighlightFeature(evt) {
  const nazwa = evt.target.getAttribute('data-nazwa');

  const overlaySource = linkOverlay.getSource();
  overlaySource.forEachFeature(feature => {
    if (feature.get('nazwa') === nazwa) {
      overlaySource.removeFeature(feature);
    }
  });
}

/////-------get coordinates----------------------------------------------------

const contextmenu = new ContextMenu({
  width: 170,
  defaultItems: false, // defaultItems are (for now) Zoom In/Zoom Out
  items: [
    {
      text: 'Kopiuj współrzędne',
      classname: 'some-style-class', // add some CSS rules
      callback: copy, // `center` is your callback function
    },
  ],
});
map.addControl(contextmenu);

let coords = '';

map.getViewport().addEventListener('contextmenu', function (evt) {
  evt.preventDefault();
  coords = transform(map.getEventCoordinate(evt), 'EPSG:3857', 'EPSG:4326');
})

// Control
var notification = new Notification({
});
map.addControl(notification);

function copy() {

  navigator.clipboard.writeText(coords[1].toFixed(6) + ', ' + coords[0].toFixed(6));

  var div = $('<div>').text('Współrzędne skopiowane ');
  $('<a>').text('ok')
    .click(function () {
      notification.hide();
    })
    .appendTo(div);
  notification.show(div.get(0));

}

/////-------Zoom Box (magnifying glass)----------------------------------------------------
// Force zoomOffset to 0
$(document).ready(function () {
  $("#zoom").val(0);
  magnifiedMaps.set("zoomOffset", 0);
});

// Make selected layers visible 
function setOVLayer(n) {
  mapsToMagnify.forEach(layer => layer.setVisible(false));
  mapsToMagnify[n].setVisible(true);
}

//ZoomBox as separate html code
var zoomBox = './assets/data/zoomBox.html'

$(document).ready(function () {
  $(".options").load(zoomBox, function () {
    $("#layerSelect").on("change", function () {
      setOVLayer(Number($(this).val()));
      $("#magnifyOpacityValue").val(100);
      $(".ol-magnify .ol-layer").css("opacity", 1);
    });

    $("#layerSelect").val("0");
    setOVLayer(0);
  });

  // Change zoom value
  $(document).on("input", "#zoom", function () {
    let zoomValue = Number($(this).val());
    magnifiedMaps.set("zoomOffset", zoomValue);
  });

  // Change glass size
  $(document).on("input", "#magnifyWidth, #magnifyHeight", function () {
    let width = $("#magnifyWidth").val() + "px";
    let height = $("#magnifyHeight").val() + "px";

    $(".ol-overlay-container .ol-magnify").css({
      width: width,
      height: height
    });
  });

  // Change opacity value
  $(document).on("input", "#magnifyOpacityValue", function () {
    let value = $(this).val();
    if (value >= 0 && value <= 100) {
      let opacity = value / 100;
      $(".ol-magnify .ol-layer").css("opacity", opacity);
    }
  });
});

map.addOverlay(magnifiedMaps)

// ZoomBox toggle button
let magnifyContainer = $(".ol-magnify");
magnifyContainer.addClass("hidden");

$("#zoomBox").prop("checked", false);
$("#zoomBox").change(function () {
  if ($(this).prop("checked")) {
    magnifyContainer.removeClass("hidden");
    magnifyContainer.addClass("active");
  } else {
    magnifyContainer.removeClass("active");
    magnifyContainer.addClass("hidden");
  }
});

//----------------------------------------------alert-------------------------------------------------------------------------

const alertPlaceholder = document.getElementById('liveAlertPlaceholder')

const appendAlert = (title, message, type) => {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = [
    `<div class="alert alert-${type} alert-dismissible" role="alert">`,
    `   <div><h4 class="alert-heading">${title}</h4> 
    ${message}</div>`,
    '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
    '</div>'
  ].join('')

  alertPlaceholder.append(wrapper)
}

try {
  let response = await fetch('https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms')
  if (!response.ok) // or check for response.status
    throw new Error(response.statusText);
  let body = await response.text(); // or .json() or whatever
} catch (err) {
  appendAlert('Wystąpiła awaria serwera.', 'Przepraszamy za niedogodności, aktualnie pracujemy nad przywróceniem usługi.', 'danger')
}










